module.exports = __webpack_public_path__ + "img/avatar-1.f627f47a.jpg";